<template>
  <div :class="['loader-shimmer', getSize]"></div>
</template>
<script setup>
import { computed } from "vue";


const props = defineProps({
  size: {
    default: 'sm',
    type: String,
    validator: (value) => {
      return ['sm', 'md', 'lg'].includes(value);
    },
  },
})

const getSize = computed(() => {
  return props.size;
});

</script>
<style lang="scss" scoped>
.loader-shimmer {
  position: relative;
  height: 16px;
  width: 100%;
  border-radius: 4px;
  animation-duration: 3s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: inlineLoader;
  animation-timing-function: linear;
  background-color: $neutral-10;
  background-image: linear-gradient(
    to right,
    $neutral-10 0%,
    $neutral-20 20%,
    $neutral-10 40%
  );
  background-size: 800px 104px;
}

@keyframes inlineLoader {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

.sm {
  height: 16px;
}
.md {
  height: 32px ;
}
.lg {
  height: 48px;
}
</style>
